import { ChangeDetectionStrategy, Component, EventEmitter, Input, Optional, Output, Self } from '@angular/core';
import { ControlContainer, FormGroupDirective, NgControl, ReactiveFormsModule } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { SelectButtonChangeEvent, SelectButtonModule } from 'primeng/selectbutton';
import { AbstractControlToFormControlPipe } from '../../../pipes/abstract-control-to-form-control.pipe';

@Component({
  selector: 'shared-select-button',
  imports: [ReactiveFormsModule, SelectButtonModule, AbstractControlToFormControlPipe],
  templateUrl: './select-button.component.html',
  styleUrls: ['./select-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class SelectButtonComponent {
  @Input() options: SelectItem[] = [];
  @Input() multiple = false;

  /* eslint-disable @angular-eslint/no-output-on-prefix */
  @Output() onChange = new EventEmitter<SelectButtonChangeEvent>();
  /* eslint-enable @angular-eslint/no-output-on-prefix */

  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      // trick it into thinking control has a valueAccessor, we don't need it because child has
      this.ngControl.valueAccessor = {
        writeValue(): void {
          // do nothing
        },
        registerOnChange(): void {
          // do nothing
        },
        registerOnTouched(): void {
          // do nothing
        },
      };
    }
  }

  valueChange(event: SelectButtonChangeEvent): void {
    // Workaround, because PrimeNG doesn't change the touched state of formControl. It is needed to show invalid state.
    this.ngControl.control?.markAsTouched();

    this.onChange.emit(event);
  }
}
